import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteGoGoLiveParentGuideMutationVariables = Types.Exact<{
  goGoLiveParentGuideId: Types.Scalars['Int']['input'];
}>;


export type DeleteGoGoLiveParentGuideMutation = { __typename?: 'Mutation', deleteGoGoLiveParentGuide: { __typename?: 'ResultResponse', count: number, error?: string | null } };


export const DeleteGoGoLiveParentGuideDocument = gql`
    mutation DeleteGoGoLiveParentGuide($goGoLiveParentGuideId: Int!) {
  deleteGoGoLiveParentGuide(goGoLiveParentGuideId: $goGoLiveParentGuideId) {
    count
    error
  }
}
    `;
export type DeleteGoGoLiveParentGuideMutationFn = Apollo.MutationFunction<DeleteGoGoLiveParentGuideMutation, DeleteGoGoLiveParentGuideMutationVariables>;

/**
 * __useDeleteGoGoLiveParentGuideMutation__
 *
 * To run a mutation, you first call `useDeleteGoGoLiveParentGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGoGoLiveParentGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGoGoLiveParentGuideMutation, { data, loading, error }] = useDeleteGoGoLiveParentGuideMutation({
 *   variables: {
 *      goGoLiveParentGuideId: // value for 'goGoLiveParentGuideId'
 *   },
 * });
 */
export function useDeleteGoGoLiveParentGuideMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGoGoLiveParentGuideMutation, DeleteGoGoLiveParentGuideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGoGoLiveParentGuideMutation, DeleteGoGoLiveParentGuideMutationVariables>(DeleteGoGoLiveParentGuideDocument, options);
      }
export type DeleteGoGoLiveParentGuideMutationHookResult = ReturnType<typeof useDeleteGoGoLiveParentGuideMutation>;
export type DeleteGoGoLiveParentGuideMutationResult = Apollo.MutationResult<DeleteGoGoLiveParentGuideMutation>;
export type DeleteGoGoLiveParentGuideMutationOptions = Apollo.BaseMutationOptions<DeleteGoGoLiveParentGuideMutation, DeleteGoGoLiveParentGuideMutationVariables>;